import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ContactFormContext } from "@insite/content-library/Widgets/ContactUs/ContactForm";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    label = "label",
    hintText = "hintText",
    isRequired = "isRequired",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
        [fields.hintText]: string;
        [fields.isRequired]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    referenceNumber: state.components.contactUsForm.fieldValues["referenceNumber"],
    isAuthenticated: state.context?.session.isAuthenticated,
    sessionData: state.context?.session,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ReferenceNumberStyles {
    firstNameTextField?: TextFieldPresentationProps;
}

export const referenceNumberStyles: ReferenceNumberStyles = {};

const styles = referenceNumberStyles;

const FirstName: React.FC<Props> = ({ fields, referenceNumber, isAuthenticated, sessionData, setFieldValue }) => {
    const { label, hintText, isRequired } = fields;
    const contactFormContext = React.useContext(ContactFormContext);
    const [userReferenceNumber, setReferenceNumber] = React.useState(referenceNumber);
    const [referenceNumberErrorMessage, setReferenceNumberErrorMessage] = React.useState("");

    React.useEffect(() => {
        contactFormContext.validators.referenceNumber = validateReferenceNumber;
        if (typeof userReferenceNumber !== "undefined") {
            if (userReferenceNumber.length < 2 && userReferenceNumber.length > 0) {
                validateReferenceNumber("MinField_Required");
            } else {
                validateReferenceNumber("Field_Required");
            }
        }
    }, [userReferenceNumber]);

    // React.useEffect(() => {
    //     if (isAuthenticated) {
    //         const name = `${sessionData.firstName} ${sessionData.lastName}`;
    //         setUserFirstName(name);
    //         setFieldValue({ key: "firstName", value: name });
    //     }
    // }, []);

    React.useEffect(() => {
        contactFormContext.validators.referenceNumber = validateReferenceNumber;
    }, [isRequired]);

    const validateReferenceNumber = (error: any = "Field_Required") => {
        const errorMessage =
            isRequired && !userReferenceNumber
                ? (siteMessage(error, label) as string)
                : typeof referenceNumber !== "undefined"
                  ? referenceNumber?.length < 2
                      ? (siteMessage(error, label) as string)
                      : ""
                  : "";
        setReferenceNumberErrorMessage(errorMessage);
        return !errorMessage;
    };

    const referenceNumberChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFieldValue({ key: "referenceNumber", value: event.target.value });
        setReferenceNumber(event.target.value);
    };

    return (
        <TextField
            {...styles.firstNameTextField}
            label={label}
            required={isRequired}
            placeholder={hintText}
            value={userReferenceNumber || ""}
            error={referenceNumberErrorMessage}
            onChange={referenceNumberChangeHandler}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(FirstName),
    definition: {
        group: "Contact Us",
        icon: "input-pipe",
        fieldDefinitions: [
            {
                name: fields.label,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Reference Number",
                isRequired: true,
            },
            {
                name: fields.hintText,
                displayName: "Hint Text",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Enter Reference Number",
                isRequired: true,
            },
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
